module.exports = __webpack_public_path__ + "img/rpa-analysis.a8634c41.webp";